import shopifyGenericDefaults from '../shopify-generic/config.js';

const baseInitFunc = shopifyGenericDefaults.InitFunc;
const InitFunc = () => {
  baseInitFunc?.();

  // remove loading class from add to cart buttons when cart modal is opened
  window.document.addEventListener('modal-open', () => {
    const loadingAddToCartButtons = [
      ...window.document.querySelectorAll(
        '.cm_product-item__buttons .\\#product-card-quick-action .\\!loading',
      ),
    ];

    loadingAddToCartButtons.forEach((button) => {
      button.classList.remove('!loading');
    });
  });
};

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  InitFunc,
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter((w) => !['SearchVehicleWidget'].includes(w.name)),

    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters && shopifyGenericDefaults.fitmentSearch.baseFields,
      facetToggleConfig: {
        toggledFacet: { field: 'Universal', term: 'True' },
      },
    },
  ],
};
